module.exports = __webpack_public_path__ + "img/v1_no4_p1.5129cf75.jpg";